"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault")["default"];

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.EthnicityFields = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _createSuper2 = _interopRequireDefault(require("@babel/runtime/helpers/createSuper"));

var _react = _interopRequireDefault(require("react"));

var _reactRedux = require("react-redux");

var _reduxForm = require("redux-form");

var _reactTransitionGroup = require("react-transition-group");

var _FieldLabel = _interopRequireDefault(require("../../ui/FieldLabel"));

var _ethnicityConfig = require("./ethnicityConfig");

var _types = require("../../types");

var _flowRuntime = _interopRequireDefault(require("flow-runtime"));

var HTMLSelectEvent = _flowRuntime["default"].tdz(function () {
  return _types.HTMLSelectEvent;
});

var InputStyle = _flowRuntime["default"].tdz(function () {
  return _types.InputStyle;
});

var FieldProps = _flowRuntime["default"].tdz(function () {
  return _reduxForm.FieldProps;
});

var Props = _flowRuntime["default"].type("Props", _flowRuntime["default"].object(_flowRuntime["default"].property("ethnicity", _flowRuntime["default"].object()), _flowRuntime["default"].property("ethnicityValue", _flowRuntime["default"].string()), _flowRuntime["default"].property("inputStyle", _flowRuntime["default"].ref(InputStyle)), _flowRuntime["default"].property("isRequired", _flowRuntime["default"]["boolean"]())));

var RenderProps = _flowRuntime["default"].type("RenderProps", _flowRuntime["default"].intersection(Props, _flowRuntime["default"].ref(FieldProps)));

var State = _flowRuntime["default"].type("State", _flowRuntime["default"].exactObject(_flowRuntime["default"].property("showMainGroup", _flowRuntime["default"]["boolean"]()), _flowRuntime["default"].property("selectedGroup", _flowRuntime["default"].string(), true)));

var groups = function groups(mainGroupSelector) {
  switch (mainGroupSelector) {
    case 'ukIreland':
      return _ethnicityConfig.ukIreland;

    case 'africaCaribbean':
      return _ethnicityConfig.africaCaribbean;

    case 'europe':
      return _ethnicityConfig.europe;

    case 'asian':
      return _ethnicityConfig.asian;

    case 'mixed':
      return _ethnicityConfig.mixed;

    case 'other':
      return _ethnicityConfig.other;

    case 'otherWhite':
      return _ethnicityConfig.otherWhite;

    default:
      return undefined;
  }
};

var EthnicityFields = /*#__PURE__*/function (_React$Component) {
  (0, _inherits2["default"])(EthnicityFields, _React$Component);

  var _super = (0, _createSuper2["default"])(EthnicityFields);

  function EthnicityFields() {
    var _this;

    (0, _classCallCheck2["default"])(this, EthnicityFields);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    _this.state = {
      showMainGroup: true,
      selectedGroup: undefined
    };

    _this.reset = function (e) {
      e.preventDefault();
      var onChange = _this.props.input.onChange;
      onChange('');

      _this.setState({
        showMainGroup: true,
        selectedGroup: undefined
      });
    };

    _this.handleMainGroupChange = function (e) {
      var onChange = _this.props.input.onChange;

      if (e.target.value === "Don't know" || e.target.value === 'Declined to answer') {
        _this.setState({
          showMainGroup: true,
          selectedGroup: e.target.value
        });

        onChange(e.target.value);
      } else {
        _this.setState({
          showMainGroup: false,
          selectedGroup: e.target.value
        });

        onChange('');
      }
    };

    _this.handleSubGroupChange = function (e) {
      var onChange = _this.props.input.onChange;

      _this.setState({
        showMainGroup: false
      });

      onChange(e.target.value);
    };

    return _this;
  }

  (0, _createClass2["default"])(EthnicityFields, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var ethnicityValue = this.props.ethnicityValue; // if ethnicityValue is within a subGroup, then select that subGroup

      if (ethnicityValue) {
        var group = _ethnicityConfig.groupList.find(function (g) {
          return g.items && g.items.find(function (item) {
            return item.key === ethnicityValue;
          });
        });

        if (group) {
          // eslint-disable-next-line react/no-did-mount-set-state
          this.setState({
            showMainGroup: false,
            selectedGroup: group.key
          });
        }
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$state = this.state,
          selectedGroup = _this$state.selectedGroup,
          showMainGroup = _this$state.showMainGroup;
      var _this$props = this.props,
          ethnicity = _this$props.ethnicity,
          ethnicityValue = _this$props.ethnicityValue,
          inputStyle = _this$props.inputStyle,
          isRequired = _this$props.isRequired;
      var subGroup = selectedGroup && groups(selectedGroup);
      return /*#__PURE__*/_react["default"].createElement("div", {
        className: "ethnicity radio"
      }, /*#__PURE__*/_react["default"].createElement(_FieldLabel["default"], {
        field: ethnicity,
        isRequired: isRequired
      }), /*#__PURE__*/_react["default"].createElement(_reactTransitionGroup.CSSTransition, {
        "in": showMainGroup,
        classNames: "fade",
        timeout: {
          enter: 300,
          exit: 0
        },
        unmountOnExit: true
      }, /*#__PURE__*/_react["default"].createElement("div", null, _ethnicityConfig.mainGroup.items && _ethnicityConfig.mainGroup.items.map(function (item) {
        return /*#__PURE__*/_react["default"].createElement("label", {
          key: item.key,
          htmlFor: item.key,
          className: inputStyle.controlClass
        }, /*#__PURE__*/_react["default"].createElement("input", {
          id: item.key,
          name: _ethnicityConfig.mainGroup.key,
          type: "radio",
          value: item.value || item.key,
          onChange: _this2.handleMainGroupChange,
          checked: (item.value || item.key) === ethnicityValue,
          className: inputStyle.indicatorClass
        }), /*#__PURE__*/_react["default"].createElement("span", null, item.label || item.key));
      }))), /*#__PURE__*/_react["default"].createElement(_reactTransitionGroup.CSSTransition, {
        "in": !showMainGroup,
        classNames: "slide-left",
        timeout: {
          enter: 1000,
          exit: 0
        },
        unmountOnExit: true
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: "ethnicity-helpers"
      }, /*#__PURE__*/_react["default"].createElement("button", {
        onClick: this.reset,
        className: "back",
        id: "back",
        type: "button",
        "aria-label": "back"
      }), subGroup && subGroup.items && subGroup.items.map(function (item) {
        return /*#__PURE__*/_react["default"].createElement("label", {
          key: item.key,
          htmlFor: item.key,
          className: inputStyle.controlClass
        }, /*#__PURE__*/_react["default"].createElement("input", {
          id: item.key,
          name: subGroup.key,
          type: "radio",
          value: item.value || item.key,
          onChange: _this2.handleSubGroupChange,
          checked: (item.value || item.key) === ethnicityValue,
          className: inputStyle.indicatorClass
        }), /*#__PURE__*/_react["default"].createElement("span", null, item.key));
      }))));
    }
  }]);
  return EthnicityFields;
}(_react["default"].Component);

exports.EthnicityFields = EthnicityFields;
var selector = (0, _reduxForm.formValueSelector)('form');

var mapStateToProps = function mapStateToProps(state, ownProps) {
  var name = ownProps.input.name;
  return {
    ethnicityValue: selector(state, name)
  };
}; // $FlowFixMe WEB-352


var _default = (0, _reactRedux.connect)(mapStateToProps)(EthnicityFields);

exports["default"] = _default;